import { AsyncThunk, AsyncThunkConfig, createAsyncThunk, GetThunkAPI } from "@reduxjs/toolkit";
import { gql } from "@apollo/client";
import { AsyncEntityThunkConfig } from "./asyncEntityStateUtil";
import { ConsumptionsWithIdentifier } from "./fetchConsumptionByIds";
import { Filter } from "./enqueueFetcher";


interface ConsumptionByFilterResponse {
  consumption: {
    aggregatedByFilter: ConsumptionsWithIdentifier
  }
}

const CONSUMPTION_BY_FILTER = gql`
  query ConsumptionAggregatedByFilter($domain: String!, $filters: [SimpleAnimalQueryFilter!]!) {
    consumption {
      aggregatedByFilter(domain: $domain, filters: $filters) {
        target_id
        consumptions: aggregated_consumptions {
          progressed: accumulated_amount
          total: expected_amount
          milestoneDayOffset: milestone_day_offset
          componentId: fk_components
        }
        count
      }
    }
  }
`



export const fetchConsumptionByFilter = createAsyncThunk(
  `consumption/fetchByFilter`,
  async (filters: Filter[] , thunkApi: GetThunkAPI<AsyncEntityThunkConfig<ConsumptionsWithIdentifier>>) => {
    const {getApolloClient} = thunkApi.extra;
    const state = thunkApi.getState();
    const domain = state.activeData.farm;
  
    if (!domain) {
      thunkApi.rejectWithValue([]);
    }
  
    try {
      const client = getApolloClient();
      const queryResponse = await client.query<ConsumptionByFilterResponse>({query: CONSUMPTION_BY_FILTER, variables: {domain, filters}})
      return thunkApi.fulfillWithValue(queryResponse.data.consumption.aggregatedByFilter);
    } catch (error) {
      return thunkApi.rejectWithValue([]);
    }
  }
) satisfies AsyncThunk<ConsumptionsWithIdentifier, Filter[], AsyncThunkConfig> as AsyncThunk<ConsumptionsWithIdentifier, Filter[], AsyncThunkConfig>
